





















import { Vue } from "@/types.ts";

export default Vue.extend({
  data() {
    return {
      email: "",
      error: null as string | null,
      password: "",
    };
  },
  methods: {
    async login() {
      this.error = null;
      await this.$store.dispatch("login", {
        email: this.email,
        password: this.password,
      });
      try {
        await this.$store.dispatch("loadAdministrators");
        await this.$store.dispatch("loadElections");
        this.$router.push({ name: "Admin" });
      } catch (e) {
        this.error =
          "La connexion a échoué, veuillez vérifier votre courriel et mot de passe.";
      }
    },
  },
  name: "Login",
});
